import * as React from 'react';
import { useState } from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Button, Grid, Paper, TextField, Alert } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';
import ModalComp from './modal-comp';
import { api_url } from '../config';
import ViewModal from './view-modal';

// import Tree from './tree.png'

function preventDefault(event) {
  event.preventDefault();
}

export default function Deposits({ tree_id, token, fetch, is_image1_uploaded, is_image2_uploaded, is_image3_uploaded, is_image4_uploaded, is_image5_uploaded }) {

  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState(false);

  // const handleDownload = async () => {

  //   try {
  //     setLoader(true);

  //     const { data: obj } = await axios({
  //       url: api_url + '/download-tree-data',
  //       method: 'post',
  //       responseType: 'json',
  //       data: {
  //         token: token,
  //         tree_id: tree_id,
  //       }
  //     })

  //     console.log(obj)

  //   }
  //   catch (e) {
  //     alert(e.message);
  //   }
  //   finally {
  //     setLoader(false);
  //   }

  // }

  return (
    <React.Fragment>
      <div style={{ justifyContent: 'center', display: "flex" }}>
        <img src="https://reliablekota.com/mission-vriksh/tree.png" alt="tree" height={"140px"} width={"150px"} />
      </div>
      <Typography style={{ textAlign: 'center' }} variant="h6"><strong>Tree No.:</strong>{tree_id}</Typography>
      <br />
      <span style={{ color: '#b11116', display: 'flex', flexDirection: 'row', justifyContent: 'center', cursor: 'pointer' }}><a href={`https://api-dot-reformexam.el.r.appspot.com/mission-vriksh/download-tree-data/?tree_id=${tree_id}`} target="_blank"><b>Download Tree Number</b></a></span><br />
      {loader && <Alert severity='success'>...Loading</Alert>}
      <Paper style={{ padding: '10px', backgroundColor: 'seashell' }}>
        <Grid container spacing={0}>
          <Grid item xs={12} md={6} lg={6}>
            <ModalComp fetch={fetch} is_image1_uploaded={is_image1_uploaded} is_image2_uploaded={is_image2_uploaded} is_image3_uploaded={is_image3_uploaded} is_image4_uploaded={is_image4_uploaded} is_image5_uploaded={is_image5_uploaded} tree_id={tree_id} token={token} />
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <ViewModal tree_id={tree_id} token={token} />
          </Grid>
        </Grid>
      </Paper>

    </React.Fragment>
  );
}